import { CountryUtils } from '@xarvio/frontend-core-platform/lib/country/CountryUtils';
import { ATInternetCustomObjectField } from './constants';

export const getGlobalVariablesByCountry = (countryCode: string) => {
  switch (countryCode) {
    case CountryUtils.COUNTRY.USA:
      return [ATInternetCustomObjectField.USER_ID];
    default:
      return [];
  }
};
